import gql from 'graphql-tag';

import integrationItemFragment from '../fragments/integrationItemFragment';

export const mutationCreateOfficeIntegrationFile = gql`
  mutation createOfficeIntegrationFile(
    $integrationID: DokkioID!
    $parentRemoteID: ID!
    $officeFileType: OfficeFileType!
    $name: String
    $dokkioTagIDs: [DokkioID!]
  ) {
    createOfficeIntegrationFile(
      integrationID: $integrationID
      parentRemoteID: $parentRemoteID
      officeFileType: $officeFileType
      name: $name
      dokkioTagIDs: $dokkioTagIDs
    ) {
      ...integrationItemFragment
    }
  }
  ${integrationItemFragment}
`;
export default mutationCreateOfficeIntegrationFile;
